const isDev = import.meta.env.MODE === 'development';

const noOp = (): void => {};

const logger = isDev
  ? {
      log: console.log.bind(console),
      warn: console.warn.bind(console),
      info: console.info.bind(console),
      error: console.error.bind(console),
    }
  : {
      log: noOp,
      warn: noOp,
      info: noOp,
      error: noOp,
    };

export default logger;

function generateErrorId(): string {
  return `err_${Date.now()}_${Math.random().toString(36).slice(2, 8)}`;
}

interface LogErrorParams {
  message: string;
  error?: any;
  code?: string;
}

export function logError({ message, error = null, code }: LogErrorParams): string {
  const safeCode = code || 'UNCLASSIFIED';

  if (error && typeof error === 'object' && !error.errorId) {
    error.errorId = `${safeCode}-${generateErrorId()}`;
  }

  const errorId: string | undefined = error?.errorId;
  const baseMessage: string = error?.userMessage || error?.message || message || 'Something went wrong';

  const payload = {
    errorId,
    code: safeCode,
    message: baseMessage,
    stack: error?.stack,
    status: error?.response?.status,
    url: error?.response?.config?.url,
    timestamp: new Date().toISOString(),
  };

  try {
    if (isDev) {
      console.error(`[AppError:${errorId}]`, payload);
    } else {
      console.error(`[ProdError:${errorId}]`);
    }
  } catch {
    // Logging must never break the app
  }

  if (isDev && safeCode && !String(baseMessage).startsWith(`[${safeCode}]`)) {
    return `[${safeCode}] ${baseMessage}`;
  }

  return baseMessage;
}
